module.exports = __webpack_public_path__ + "img/actu.08ea0902.png";